import React, { useState, useEffect } from 'react';
interface ProxyImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
}
/**
 * Componente que automáticamente usa el proxy para imágenes de WordPress
 * para evitar problemas de CORS
 */
const ProxyImage: React.FC<ProxyImageProps> = ({ src, ...props }) => {
  const [imageSrc, setImageSrc] = useState<string>(src);
  const [error, setError] = useState(false);
  const wordpressDomain = 'smartcityexposantiagodelestero.com';
  // Obtener la URL base del API - intentar diferentes métodos
  const getProxyBaseUrl = () => {
    let apiBaseUrl = process.env.REACT_APP_API_URL || '';
    
    // Si apiBaseUrl está vacío, usar window.location.origin
    if (!apiBaseUrl) {
      apiBaseUrl = window.location.origin;
    }
    
    // Normalizar: eliminar /api al final si existe para evitar duplicación
    apiBaseUrl = apiBaseUrl.replace(/\/api\/?$/, '');
    
    return apiBaseUrl;
  };
  const proxyBaseUrl = getProxyBaseUrl();
  useEffect(() => {
    // Si la imagen es de WordPress, usar el proxy
    if (src && src.includes(wordpressDomain)) {
      const proxyUrl = `${proxyBaseUrl}/api/proxy-image?url=${encodeURIComponent(src)}`;
      setImageSrc(proxyUrl);
      setError(false);
    } else {
      setImageSrc(src);
      setError(false);
    }
  }, [src, proxyBaseUrl]);
  const handleError = () => {
    // Si falla la carga a través del proxy, intentar con la URL original
    if (imageSrc.includes('/api/proxy-image')) {
      setImageSrc(src);
      setError(true);
    }
  };
  return <img src={imageSrc} {...props} onError={handleError} />;
};
export default ProxyImage;
